import { render } from "./ProductPage.vue?vue&type=template&id=6e5a8f1c&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"

import "./ProductPage.vue?vue&type=style&index=0&id=6e5a8f1c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5a8f1c"]])

export default __exports__